<div class="modalBlocking">
  <ng-container *ngIf="!isBlocked; else unblock">
    <div class="modalBlocking__qst vc-text-xl">
      <span i18n="@@CHAT.MODAL.BLOCK_USER">Block {{ data.receiver.username }}</span>
      <button class="modalBlocking__qst__close vc-text-s" (click)="close()" i18n="@@CHAT.MODAL.CTA.CLOSE">
        Close
        <vc-sprite-icons class="modalBlocking__qst__close__svg" name="cross-x"></vc-sprite-icons>
      </button>
    </div>
    <p class="modalBlocking__info vc-text-m" i18n="@@CHAT.MODAL.BLOCK_USER_WARNING">
      {{ data.receiver.username }} won't be able to talk to you.
    </p>
    <div class="modalBlocking__action">
      <button
        class="modalBlocking__action__cancel vc-btn vc-btn--outline vc-btn--small"
        (click)="close()"
        i18n="@@CHAT.MODAL.CTA.CANCEL"
      >
        Cancel
      </button>
      <button
        class="modalBlocking__action__confirm vc-btn vc-btn--primary vc-btn--small"
        (click)="blockUser()"
        i18n="@@CHAT.MODAL.CTA.BLOCK_USER"
      >
        Block
      </button>
    </div>
  </ng-container>

  <ng-template #unblock>
    <div class="modalBlocking__qst vc-text-xl">
      <span i18n="@@CHAT.MODAL.UNBLOCK_USER">Unblock {{ data.receiver.username }}</span>
      <button class="modalBlocking__qst__close vc-text-s" (click)="close()" i18n="@@CHAT.MODAL.CTA.CLOSE">
        Close
        <vc-sprite-icons class="modalBlocking__qst__close__svg" name="cross-x"></vc-sprite-icons>
      </button>
    </div>
    <p class="modalBlocking__info vc-text-m" i18n="@@CHAT.MODAL.UNBLOCK_USER_WARNING">
      {{ data.receiver.username }} can talk to you again.
    </p>
    <div class="modalBlocking__action">
      <button
        class="modalBlocking__action__cancel vc-btn vc-btn--outline vc-btn--small"
        (click)="close()"
        i18n="@@CHAT.MODAL.CTA.CANCEL"
      >
        Cancel
      </button>
      <button
        class="modalBlocking__action__confirm vc-btn vc-btn--primary vc-btn--small"
        (click)="unblockUser()"
        i18n="@@CHAT.MODAL.CTA.UNBLOCK_USER"
      >
        Unblock
      </button>
    </div>
  </ng-template>
</div>
